/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BadRequestErrorResponse,
    BadRequestErrorResponseFromJSON,
    BadRequestErrorResponseToJSON,
    ConflictErrorResponse,
    ConflictErrorResponseFromJSON,
    ConflictErrorResponseToJSON,
    FirmwareResponse,
    FirmwareResponseFromJSON,
    FirmwareResponseToJSON,
    NewResourceResponse,
    NewResourceResponseFromJSON,
    NewResourceResponseToJSON,
    NotFoundErrorResponse,
    NotFoundErrorResponseFromJSON,
    NotFoundErrorResponseToJSON,
    StbGroupNameResponse,
    StbGroupNameResponseFromJSON,
    StbGroupNameResponseToJSON,
    StbGroupRequest,
    StbGroupRequestFromJSON,
    StbGroupRequestToJSON,
    StbGroupResponse,
    StbGroupResponseFromJSON,
    StbGroupResponseToJSON,
    StbGroupsResponse,
    StbGroupsResponseFromJSON,
    StbGroupsResponseToJSON,
} from '../models';

export interface CreateStbGroupRequest {
    stbGroupRequest: StbGroupRequest;
    makeDefault?: boolean | null;
}

export interface DeleteStbGroupRequest {
    id: string;
}

export interface MoveDevicesRequest {
    id: string;
    requestBody: Array<string>;
}

export interface ReadNotEmptyStbGroupsRequest {
    filterDeviceTypeId?: string | null;
}

export interface ReadStbGroupRequest {
    id: string;
}

export interface ReadStbGroupFirmwaresRequest {
    id: string;
}

export interface ReadStbGroupsRequest {
    mode?: ReadStbGroupsModeEnum;
    filter?: string | null;
    filterDeviceTypeId?: string | null;
    filterStbGroupId?: string | null;
    filterSuperGroupId?: string | null;
    offset?: number | null;
    limit?: number | null;
    orderBy?: string | null;
    direction?: ReadStbGroupsDirectionEnum;
}

export interface UpdateStbGroupRequest {
    id: string;
    stbGroupRequest: StbGroupRequest;
}

/**
 * 
 */
export class StbGroupsApi extends runtime.BaseAPI {

    /**
     * Create a new STB group.
     */
    async createStbGroupRaw(requestParameters: CreateStbGroupRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<NewResourceResponse>> {
        if (requestParameters.stbGroupRequest === null || requestParameters.stbGroupRequest === undefined) {
            throw new runtime.RequiredError('stbGroupRequest','Required parameter requestParameters.stbGroupRequest was null or undefined when calling createStbGroup.');
        }

        const queryParameters: any = {};

        if (requestParameters.makeDefault !== undefined) {
            queryParameters['makeDefault'] = requestParameters.makeDefault;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stbGroups`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StbGroupRequestToJSON(requestParameters.stbGroupRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NewResourceResponseFromJSON(jsonValue));
    }

    /**
     * Create a new STB group.
     */
    async createStbGroup(requestParameters: CreateStbGroupRequest, initOverrides?: RequestInit): Promise<NewResourceResponse> {
        const response = await this.createStbGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete STB group by ID.
     */
    async deleteStbGroupRaw(requestParameters: DeleteStbGroupRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteStbGroup.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stbGroups/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete STB group by ID.
     */
    async deleteStbGroup(requestParameters: DeleteStbGroupRequest, initOverrides?: RequestInit): Promise<void> {
        await this.deleteStbGroupRaw(requestParameters, initOverrides);
    }

    /**
     * Update STB group by ID.
     */
    async moveDevicesRaw(requestParameters: MoveDevicesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling moveDevices.');
        }

        if (requestParameters.requestBody === null || requestParameters.requestBody === undefined) {
            throw new runtime.RequiredError('requestBody','Required parameter requestParameters.requestBody was null or undefined when calling moveDevices.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stbGroups/{id}/devices`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update STB group by ID.
     */
    async moveDevices(requestParameters: MoveDevicesRequest, initOverrides?: RequestInit): Promise<void> {
        await this.moveDevicesRaw(requestParameters, initOverrides);
    }

    /**
     * Read only names and ids of all stbGroups
     */
    async readNamesIdsStbGroupsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<StbGroupNameResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stbGroups/names`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(StbGroupNameResponseFromJSON));
    }

    /**
     * Read only names and ids of all stbGroups
     */
    async readNamesIdsStbGroups(initOverrides?: RequestInit): Promise<Array<StbGroupNameResponse>> {
        const response = await this.readNamesIdsStbGroupsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Read not empty (with devices) STB groups.
     */
    async readNotEmptyStbGroupsRaw(requestParameters: ReadNotEmptyStbGroupsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<StbGroupNameResponse>>> {
        const queryParameters: any = {};

        if (requestParameters.filterDeviceTypeId !== undefined) {
            queryParameters['filterDeviceTypeId'] = requestParameters.filterDeviceTypeId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stbGroups/notEmpty`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(StbGroupNameResponseFromJSON));
    }

    /**
     * Read not empty (with devices) STB groups.
     */
    async readNotEmptyStbGroups(requestParameters: ReadNotEmptyStbGroupsRequest = {}, initOverrides?: RequestInit): Promise<Array<StbGroupNameResponse>> {
        const response = await this.readNotEmptyStbGroupsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Read STB group by ID.
     */
    async readStbGroupRaw(requestParameters: ReadStbGroupRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<StbGroupResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling readStbGroup.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stbGroups/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StbGroupResponseFromJSON(jsonValue));
    }

    /**
     * Read STB group by ID.
     */
    async readStbGroup(requestParameters: ReadStbGroupRequest, initOverrides?: RequestInit): Promise<StbGroupResponse> {
        const response = await this.readStbGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Read STB group firmwares by ID.
     */
    async readStbGroupFirmwaresRaw(requestParameters: ReadStbGroupFirmwaresRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<{ [key: string]: Array<FirmwareResponse>; }>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling readStbGroupFirmwares.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stbGroups/{id}/firmwares`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Read STB group firmwares by ID.
     */
    async readStbGroupFirmwares(requestParameters: ReadStbGroupFirmwaresRequest, initOverrides?: RequestInit): Promise<{ [key: string]: Array<FirmwareResponse>; }> {
        const response = await this.readStbGroupFirmwaresRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Read STB groups.
     */
    async readStbGroupsRaw(requestParameters: ReadStbGroupsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<StbGroupsResponse>> {
        const queryParameters: any = {};

        if (requestParameters.mode !== undefined) {
            queryParameters['mode'] = requestParameters.mode;
        }

        if (requestParameters.filter !== undefined) {
            queryParameters['filter'] = requestParameters.filter;
        }

        if (requestParameters.filterDeviceTypeId !== undefined) {
            queryParameters['filterDeviceTypeId'] = requestParameters.filterDeviceTypeId;
        }

        if (requestParameters.filterStbGroupId !== undefined) {
            queryParameters['filterStbGroupId'] = requestParameters.filterStbGroupId;
        }

        if (requestParameters.filterSuperGroupId !== undefined) {
            queryParameters['filterSuperGroupId'] = requestParameters.filterSuperGroupId;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.orderBy !== undefined) {
            queryParameters['orderBy'] = requestParameters.orderBy;
        }

        if (requestParameters.direction !== undefined) {
            queryParameters['direction'] = requestParameters.direction;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stbGroups`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StbGroupsResponseFromJSON(jsonValue));
    }

    /**
     * Read STB groups.
     */
    async readStbGroups(requestParameters: ReadStbGroupsRequest = {}, initOverrides?: RequestInit): Promise<StbGroupsResponse> {
        const response = await this.readStbGroupsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update STB group by ID.
     */
    async updateStbGroupRaw(requestParameters: UpdateStbGroupRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateStbGroup.');
        }

        if (requestParameters.stbGroupRequest === null || requestParameters.stbGroupRequest === undefined) {
            throw new runtime.RequiredError('stbGroupRequest','Required parameter requestParameters.stbGroupRequest was null or undefined when calling updateStbGroup.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stbGroups/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: StbGroupRequestToJSON(requestParameters.stbGroupRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update STB group by ID.
     */
    async updateStbGroup(requestParameters: UpdateStbGroupRequest, initOverrides?: RequestInit): Promise<void> {
        await this.updateStbGroupRaw(requestParameters, initOverrides);
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ReadStbGroupsModeEnum {
    Default = 'DEFAULT',
    NoIpAddressOnly = 'NO_IP_ADDRESS_ONLY'
}
/**
    * @export
    * @enum {string}
    */
export enum ReadStbGroupsDirectionEnum {
    Asc = 'ASC',
    Desc = 'DESC'
}
